import { LanguageDetails } from "domain/language";
import { getObject, RepositoryKey, setObject } from "utils/repository";

// Note that UI testing automation will come to rely on the _code_ format xx_YY
// so it can't be changed.
const LANGUAGES: LanguageDetails[] = [
    { locale: "EN", title: "English", code: "en_US" },
    { locale: "FR", title: "Français", code: "fr_FR" },
    { locale: "DE", title: "Deutsch", code: "de_DE" },
    { locale: "JA", title: "日本語", code: "ja_JP" },
    { locale: "ES", title: "Español", code: "es_ES" },
    { locale: "PT", title: "Português", code: "pt_BR" },
    { locale: "CN", title: "中文", code: "zh_CN" },
    { locale: "KR", title: "한국어", code: "ko_KR" },
];

const DEFAULT_LANGUAGE = LANGUAGES[0];

export function getAllLanguages(): LanguageDetails[] {
    return LANGUAGES;
}

export function getLanguage(): LanguageDetails {
    if (getObject(RepositoryKey.LOCALE) === null) {
        setLanguage(DEFAULT_LANGUAGE.locale);
    }
    const locale = getObject(RepositoryKey.LOCALE);
    return LANGUAGES.find((language) => language.locale === locale) || DEFAULT_LANGUAGE;
}

export function setLanguage(language: string): void {
    setObject(RepositoryKey.LOCALE, language);
}

export function initializeBrowserLanguage(): void {
    const browserLanguage = navigator.language.split("-")[0].toUpperCase();
    const match = LANGUAGES.find((lang) => lang.locale === browserLanguage);
    if (match && getLanguage().locale !== match.locale) {
        setLanguage(match.locale);
    }
}
